import { useQueries } from "@tanstack/react-query";
import { COLLECTIONS } from "./collections";
import { getMatchedDogCount } from "@/features/discovery";

const COUNT_STALE_MS = 5 * 60_000;

export function useCollectionCounts(
    location: { lat: number; lng: number } | null,
    enabled = true,
): Record<string, number | undefined> {
    const active = enabled && Boolean(location);

    const results = useQueries({
        queries: COLLECTIONS.map((c) => ({
            queryKey: [
                "collection-count",
                c.id,
                location?.lat ?? null,
                location?.lng ?? null,
            ] as const,
            queryFn: () => {
                if (!location) {
                    throw new Error("collection count ran without a location");
                }
                return getMatchedDogCount({
                    data: {
                        lat: location.lat,
                        lng: location.lng,
                        ...c.filters,
                    },
                });
            },
            enabled: active,
            staleTime: COUNT_STALE_MS,

            retry: 1,
        })),
    });

    const counts: Record<string, number | undefined> = {};
    COLLECTIONS.forEach((c, i) => {
        counts[c.id] = results[i]?.data;
    });
    return counts;
}
